export default "__VITE_ASSET__kTpHCyjR__"